module.exports = __webpack_public_path__ + "img/3_59.8b8f6393.png";